import { sectionHeaderStyles, DEFAULT_BORDER } from "../styles/shared/sectionHeaderStyles";
import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function TabSectionHeader({
  title,
  rightText = "",
  onAction,
  actionNode = null,
  actionDisabled = false,
  actionStartIcon = null,
  sx = {},
  titleSx = {},
  actionSx = {},
  dividerColor = DEFAULT_BORDER }) {
  return (
    <Box
      sx={sectionHeaderStyles.root({ dividerColor, sx })}
    >
      <Typography
        className="profile-section-title"
        sx={sectionHeaderStyles.title({ titleSx })}
      >
        {title}
      </Typography>

      {actionNode ? (
        actionNode
      ) : rightText ? (
        <Button
          className="tab-section-action"
          variant="text"
          size="small"
          disableRipple
          startIcon={actionStartIcon}
          onClick={onAction}
          disabled={actionDisabled}
          sx={sectionHeaderStyles.action({ actionDisabled, actionSx })}
        >
          {rightText}
        </Button>
      ) : null}
    </Box>
  );
}
